import React, { useState, useEffect, Component } from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import TableView from '../TableView';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PaymentMode = () => {
    const data = [
        { Code: '001', Payment_Mode_Name: 'CHEQUE' },
        { Code: '002', Payment_Mode_Name: 'CASH' },
    ]

    const columns = ['Code', 'Payment_Mode_Name',];

    



    return (
        <Container>
             <ToastContainer autoClose={2000} />
            <Row>
                <Col>
                    <Form className='mt-3 bottom-border pb-3'>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Code</Form.Label>
                                    <Form.Control type="text" placeholder="001" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Payment Mode</Form.Label>
                                    <Form.Control type="text" placeholder="Invoice" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className='text-center'>
                            <Col className='text-end'>
                                <Button className="ms-3" variant="primary" type="submit">
                                    New
                                </Button>

                                <Button className="ms-3" variant="primary" type="submit">
                                    Edit
                                </Button>

                                <Button className="ms-3" variant="primary" type="submit">
                                    Save
                                </Button>

                                <Button className="ms-3" variant="primary" type="submit">
                                    Delete
                                </Button>
                                
                                <Button className="ms-3" variant="primary" type="submit">
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col>
                    <TableView data={data} columns={columns} />
                </Col>
            </Row>
        </Container>
    );
}

export default PaymentMode;